import { tw } from "@careinfo/tailwind";
import { useFieldArray, useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import { getKey } from "../../helpers/sessionKey";
import { FormLayout } from "@careinfo/layout";
import ComboboxInput from "../Reusable/ComboboxInput";
import { AccessControl } from "@careinfo/permission-required";
import TextField from "../Reusable/TextInput";
import NumberField from "../Reusable/NumberField";
import ProductTypeComboboxInput from "../Reusable/ProductTypeComboBox";
import Card from "../Reusable/Card";
import TabPanel from "../Reusable/Tab";
import Form from "./Form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { EditDarazOrderValidationForm } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";

const EditDarazOrder = (props: any) => {
  const { handleEdit, isLoading, data, handleMarkAsDone, isMarkasDoneloading } = props;

  const {
    setValue,
    getValues,
    setError,
    register,
    handleSubmit,
    watch,
    control,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(EditDarazOrderValidationForm),
    defaultValues: async () => {
      return {
        ...data,
        destination:
          typeof data?.destination === "string"
            ? { name: data.destination }
            : data?.destination ?? null,
        items: data?.items?.length
          ? data.items.map((item: any) => ({
              description: item.description,
              product_type:
                typeof item.product_type === "string"
                  ? { name: item.product_type }
                  : item.product_type,
              piece: item.piece,
              weight: item.weight,
            }))
          : [
              {
                description: "",
                product_type: "",
                piece: 0,
                weight: 0,
              },
            ],
      };
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const isSuperUser = getKey("is_superuser") === "true";
  const isActive = true;
  return (
    <>
      <AccessControl
        children={
          // <FormLayout
          //   handleSubmit={handleSubmit}
          //   handleFormSubmit={handleEdit}
          //   setError={setError}
          //   buttonLabel={"Update"}
          //   isLoading={isLoading}
          // >
          <Card>
            <form
              className={tw``}
              onSubmit={handleSubmit((data) => handleEdit(data, setError))}
            >
              <Form
                errors={errors}
                register={register}
                setValue={setValue}
                getValues={getValues}
                clearErrors={clearErrors}
                fields={fields}
                isEdit={true}
                isSuperUser={isSuperUser}
                watch={watch}
                remove={remove}
                append={append}
              />
              <div className={tw`flex justify-end w-full gap-x-4 px-4`}>
                <div className={tw`w-24`}>
                  <Button
                    onClick={handleMarkAsDone}
                    type="button"
                    isLoading={isMarkasDoneloading}
                    disabled={!data?.is_active}
                    label={"Mark as Done"}
                  />
                </div>
                <div className={tw`w-24`}>
                  <Button
                    label={"Update"}
                    disabled={!data?.is_active}
                    isLoading={isLoading}
                  />
                </div>
              </div>
            </form>
          </Card>
        }
        allowedPermissions={["can_editupdate_manifest"]}
      />
    </>
  );
};

export default EditDarazOrder;
